const ProcessData = (data, setData, event, type, name, errors, setErrors) => {
  switch (type) {
    case "file":
      break;
    case "radio":
      setData({
        ...data,
        [name]: event,
      });
      setErrors({
        ...errors,
        [name]: "",
      });
      break;
    case "select":
      setData({
        ...data,
        [name]: event?.value,
      });
      setErrors({
        ...errors,
        [name]: "",
      });
      break;
    case "number":
      setData({
        ...data,
        [name]: event,
      });
      setErrors({
        ...errors,
        [name]: "",
      });
      break;

    default:
      const value = event.target.value;
      setData({
        ...data,
        [name]: value,
      });
      setErrors({
        ...errors,
        [name]: "",
      });
      break;
  }
};

export default ProcessData;
